import api from "./configuration";
import apiUrl from "./url";
export const VenueAPI = {
	list: async (params) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + "/Venues",
				params,
				useAuthInterceptor: true,
			})
		).data,
	create: async (data) =>
		(
			await api.request({
				method: "POST",
				url: apiUrl + "/Venues",
				data,
				useAuthInterceptor: true,
			})
		).data,
	update: async (id, data) =>
		(
			await api.request({
				method: "PUT",
				url: apiUrl + "/Venues/" + id,
				data,
				useAuthInterceptor: true,
			})
		).data,
	delete: async (id) =>
		api.request({
			method: "DELETE",
			url: apiUrl + "/Venues/" + id,
			useAuthInterceptor: true,
		}),
};
